import { createContext, useContext } from 'react';

export const IndustryContext = createContext(null);

export function useIndustry() {
  const ctx = useContext(IndustryContext);
  if (!ctx) {
    throw new Error('useIndustry must be used within an IndustryProvider');
  }
  return ctx;
}
